/* import __COLOCATED_TEMPLATE__ from './start-conversation-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();